// @ts-nocheck
import React from 'react';
import {
  styled, Box, Stack, Typography,
} from '@mui/material';
import { Layer } from '../models/layer-settings';
import { CheckIcon, CircleIcon } from '../icons';
import LayerPickerLayerType from './layer-picker-layer-type';

interface Props {
  item: Layer;
  onClick: (item: Layer) => void;
  active: boolean;
}

const ItemContainer = styled(Box)({
  display: 'flex',
  padding: 8,
  paddingLeft: 12,
  borderBottom: '1px solid #eee',
  fontSize: 13,
  cursor: 'pointer',
  ':hover': {
    backgroundColor: '#f7f7f7',
  },
});

const CheckContainer = styled(Box)({
  flex: '0 1 auto',
  width: 16,
  height: 16,
  overflow: 'hidden',
  alignSelf: 'center',
});

const LayerPickerAvailableLayersListItem: React.FC<Props> = ({ active, item, onClick }) => (
  <ItemContainer
    onClick={() => onClick(item)}
  >
    <Stack spacing={0.5} sx={{ minWidth: 0, flex: '1 1 auto' }}>
      <Typography data-testid="layer-title" sx={{ color: '#41403B', fontSize: '12px', maxWidth: '395px' }} noWrap>{item.name}</Typography>
      { item.description?.length > 0
        ? (
          <Typography
            data-testid="layer-description"
            sx={{
              color: 'rgba(0, 0, 0, 0.6)',
              WebkitLineClamp: '2',
              WebkitBoxOrient: 'vertical',
              maxWidth: '395px',
              lineHeight: 'inherit',
              fontSize: '12px',
              display: '-webkit-box',
              overflow: 'hidden',
            }}
          >
            {item.description}
          </Typography>
        ) : null }
      <LayerPickerLayerType
        layerType={item.type}
        origin={item.origin}
        fileSize={item.fileSize}
        username={item.esriUsername}
      />
    </Stack>
    <CheckContainer>
      {active
            && (
              <CheckIcon
                data-testid="check-icon"
                width="12"
                style={{ fill: '#7db400' }}
              />
            )}
      {!active
            && (
              <CircleIcon
                data-testid="circle-icon"
                width="14"
                style={{
                  fill: '#aaa',
                  display: 'inline-block',
                  boxSizing: 'border-box',
                  width: 16,
                  height: 16,
                  paddingTop: 2,
                  paddingLeft: 1,
                }}
              />
            )}
    </CheckContainer>
  </ItemContainer>
);

export default LayerPickerAvailableLayersListItem;
